/** @format */

import {OrderDescriptionColumn} from '../../active_orders/invoices_list/orders_list/table_columns/order_description_column';
import {LoadMoreContextual} from '../../../../components/search/load_more';
import {ActionColumn} from './table_columns/action_column';
import {DesignsList} from './designs_table/designs_list';
import DateOnly from '../../../../utilities/format/date';
import {IdColumn} from './table_columns/id_column';
import React, {useContext, useState} from 'react';
import {Table, Toast} from '@sttark/design-system';
import {SearchContext} from 'frontier-search';

// styles
import './grouped_by_order_list.scss';
import {CustomLoadMoreContextual} from '../custom_load_more_contextual';

export const GroupedByOrderList = () => {
    const ctx = useContext(SearchContext);
    const [isToastOpen, setIsToastOpen] = useState(false);

    const handleArchiveOrder = orderId => {
        ctx.handleRemoveItemFromList(orderId, true);

        setIsToastOpen(true);
    };

    return (
        <div className="grouped-by-order-list-310kv">
            <Toast
                onClose={() => setIsToastOpen(false)}
                autoHideDuration={4000}
                isOpen={isToastOpen}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">Order archived successfully!</p>
            </Toast>
            <Table
                columns={[
                    {
                        title: 'Order ID ',
                        index: 'order_id',
                        key: 'order_id'
                    },
                    {
                        index: 'product_type',
                        key: 'product_type',
                        title: 'Type'
                    },
                    {
                        title: 'Date',
                        index: 'date',
                        key: 'date'
                    },
                    {
                        index: 'description',
                        title: 'Description',
                        key: 'description'
                    },
                    {
                        index: 'action',
                        key: 'action',
                        title: ''
                    }
                ]}
                rows={ctx.listItems.map(order => {
                    return {
                        key: order.id,
                        order_id: <IdColumn order={order} />,
                        product_type: <p className="m-0 p-0">{order.product_type_label}</p>,
                        date: (
                            <p className="orders-list-table-active-31cs__column--date m-0 p-0">
                                <DateOnly>{order.created}</DateOnly>
                            </p>
                        ),
                        description: <OrderDescriptionColumn order={order} />,
                        action: (
                            <ActionColumn onRemoveItemFromList={handleArchiveOrder} order={order} />
                        ),
                        renderData: order
                    };
                })}
                isExpandable
                defaultExpanded
                borderedRows>
                <DesignsList />
            </Table>
            <div style={{marginTop: '24px'}}>
                <LoadMoreContextual>
                    <CustomLoadMoreContextual />
                </LoadMoreContextual>
            </div>
        </div>
    );
};
